import {
  forwardRef,
  ForwardRefRenderFunction,
  ReactNode,
  useCallback,
} from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import DeleteIcon from '@mui/icons-material/Delete';
import TableRow, { TableRowProps } from '@mui/material/TableRow';
import TableCell from 'components/TableCell';
import ConfirmableIconButton from 'components/ConfirmableIconButton';

import { EntityTableRow_entity$key } from '__generated__/EntityTableRow_entity.graphql';

type Props = TableRowProps & {
  entity: EntityTableRow_entity$key;
  actions?: ReactNode;
  onDelete: (id: string) => void;
};

export type EntityTableRowProps = Omit<Props, 'entity'>;

const EntityTableRow: ForwardRefRenderFunction<any, Props> = (props, ref) => {
  const { children, actions, onDelete, ...rest } = props;

  const { id, deletable } = useFragment(
    graphql`
      fragment EntityTableRow_entity on Entity {
        id
        deletable
      }
    `,
    props.entity
  );

  const handleDeleteClick = useCallback(() => {
    onDelete(id);
  }, [id, onDelete]);

  return (
    <TableRow {...rest} ref={ref}>
      {children}

      <TableCell right sx={{ whiteSpace: 'nowrap' }}>
        {actions}
        <ConfirmableIconButton
          disabled={!deletable}
          confirmText="Trinti?"
          onConfirm={handleDeleteClick}>
          <DeleteIcon fontSize="small" />
        </ConfirmableIconButton>
      </TableCell>
    </TableRow>
  );
};

export default forwardRef(EntityTableRow);
